import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-08d1bdc4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "loader"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = { key: 1 };
const _hoisted_4 = { key: 2 };
const _hoisted_5 = {
    key: 0,
    class: "service-approval-container"
};
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h4", null, "Service Review & Customer Approval", -1));
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, " Please review the completed service details and provide your signature to confirm satisfaction with the work performed. ", -1));
const _hoisted_8 = [
    _hoisted_6,
    _hoisted_7
];
const _hoisted_9 = {
    key: 4,
    class: "img-outer-container"
};
const _hoisted_10 = {
    key: 0,
    class: "photo-title"
};
const _hoisted_11 = {
    key: 5,
    class: "img-outer-container"
};
const _hoisted_12 = {
    key: 0,
    class: "photo-title"
};
const _hoisted_13 = {
    key: 6,
    class: "img-outer-container"
};
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "photo-title" }, "Rating this Service", -1));
const _hoisted_15 = {
    key: 7,
    class: "img-outer-container"
};
const _hoisted_16 = {
    key: 0,
    class: "photo-title"
};
const _hoisted_17 = { key: 8 };
const _hoisted_18 = {
    key: 0,
    class: "btn-space"
};
const _hoisted_19 = {
    key: 1,
    class: "btn-space"
};
const _hoisted_20 = {
    key: 0,
    class: "uploadText"
};
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_22 = { key: 9 };
const _hoisted_23 = {
    key: 0,
    class: "btn-space"
};
const _hoisted_24 = { class: "btm-content" };
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "Do you want to take the vehicle to the garage?", -1));
import { watch, ref, onMounted, computed, toRaw } from 'vue';
import MainLayout from '../components/MainLayout/MainLayout.vue';
import InfoBlock from '../components/info/InfoBlock.vue';
import LocationBLock from '../components/info/LocationBlock.vue';
import LocationBlockToGarage from '../components/info/LocationBlockToGarage.vue';
import DButton from '../components/button/SubmitButton.vue';
import BottomSheet from '../components/bottomSheet/BottomSheet.vue';
import EndTaskSheet from '../components/endTask/EndTaskSheet.vue';
import ImgGallery from '../components/gallery/ImageGallery.vue';
import { useRoute } from 'vue-router';
import SignaturePad from '../components/SignaturePad/SignaturePad.vue';
import axios from 'axios';
import { TowVehicleLocationType, TowVehicleServiceBookingStatus, } from '../interfaces/main-data';
import { useStore } from 'vuex';
import { TowVehicleMediaType, } from '../interfaces/tow-vehicle-media';
import ThankYou from './ThankYou.vue';
import RatingStar from '../components/rating/RatingStar.vue';
import { getApiBaseUrl, getAppName } from '../apiConfig';
import { nextTick } from 'vue';
// import { ServiceCenter } from "../components/bottomSheetGarage/BottomSheetGarage.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'HomePage',
    setup(__props) {
        const store = useStore();
        const data = ref(null);
        const loading = ref(true);
        const error = ref(null);
        const spanVisible = ref(false);
        const towToGarageClicked = ref(false);
        const fileInput = ref(null);
        const endTaskClicked = ref(false);
        const reasons = ref([]);
        const comment = ref('');
        const currentRating = ref(0);
        const finalClick = ref(false);
        const signature = ref('');
        const project = getAppName() || process.env.VUE_APP_NAME;
        const loader = ref({
            almulla: 'almulla-loader.png',
            ultimate: 'ultimate-loader.svg',
            stellantis: 'default-loader.gif',
            aljazirah: 'default-loader.gif',
            dmc: 'default-loader.gif',
        });
        const selectedServiceCenter = ref();
        // Get tow vehicle status from Vuex store
        const towVehicleStatus = computed(() => store.getters.towVehicleStatus);
        const isDestinationReached = computed(() => store.getters.isDestinationReached);
        const images = computed(() => store.getters.allImages);
        const imagesForStatus = computed(() => {
            return images.value.filter((e) => towVehicleStatus.value === TowVehicleServiceBookingStatus.PICKUP
                ? e.type === TowVehicleMediaType.COMPLETED
                : towVehicleStatus.value === TowVehicleServiceBookingStatus.STARTED
                    ? e.type === TowVehicleMediaType.ARRIVED
                    : e.type === towVehicleStatus.value);
        });
        const handleButtonClick = () => {
            const imagesForStatus = images.value.filter((e) => towVehicleStatus.value === TowVehicleServiceBookingStatus.PICKUP
                ? e.type === TowVehicleMediaType.COMPLETED
                : towVehicleStatus.value === TowVehicleServiceBookingStatus.STARTED
                    ? e.type === TowVehicleMediaType.ARRIVED
                    : e.type === towVehicleStatus.value);
            if (imagesForStatus.length === 0) {
                triggerFileUpload();
            }
            else if (endTaskClicked.value) {
                submitHandler();
            }
            else {
                toggle();
            }
        };
        const handleSignatureSave = (dataUrl) => {
            console.log('Received signature:', dataUrl);
            signature.value = dataUrl;
            // You can send this dataUrl to a server or save it to your data store
        };
        const updateRating = (rating) => {
            console.log('Selected Rating: ', toRaw(rating));
            currentRating.value = toRaw(rating);
        };
        // Computed property to check if vehicleDetails is set in the store
        // const vehicleDetailsAvailable = computed(() => store.getters.vehicleDetails?.position?.address);
        const route = useRoute();
        // Define stopWatcher and initialize it later
        let stopWatcher;
        // eslint-disable-next-line prefer-const
        stopWatcher = watch(() => store.getters.towVehicleStatus, (newStatus) => {
            if ((newStatus === TowVehicleServiceBookingStatus.STARTED ||
                newStatus === TowVehicleServiceBookingStatus.PICKUP) &&
                !isDestinationReached.value) {
                const deviceId = data.value?.towVehicleDetails?.vehicle?.deviceId;
                console.log('deviceId', deviceId);
                if (deviceId &&
                    data.value?.callLocationApiFromFrontend &&
                    project === 'ultimate') {
                    store.dispatch('startVehicleDetailsPolling', deviceId);
                }
                else {
                    store.dispatch('startLiveLocationPolling', deviceId);
                }
            }
            if (isDestinationReached.value) {
                stopWatcher(); // Stop the watcher
            }
        }, { immediate: true });
        watch(() => isDestinationReached.value, (reached) => {
            if (reached) {
                stopWatcher(); // Stop the towVehicleStatus watcher when the destination is reached
            }
        });
        // Optionally, you can also create a separate watcher for isDestinationReached
        onMounted(async () => {
            try {
                const param = route.params.id || route.fullPath.split('/').pop();
                if (!param) {
                    throw new Error('Parameter is missing');
                }
                store.commit('setRoadAssistanceId', param);
                const baseUrl = getApiBaseUrl() || process.env.VUE_APP_BASE_URL;
                const response = await axios.get(`${baseUrl}/tow-vehicle/road-assistance-details/${param}`);
                data.value = response.data.data;
                console.log('response.data.data?.reasons', response.data.data);
                // reasons.value = response.data.data?.towVehicleDetails?.reasons;
                await store.dispatch('updateTowVehicleStatus', data.value?.towVehicleDetails?.status || '');
                // store.commit("setDetail", data.value);
                console.log('adfa', data?.value?.useTowVehicleTrueLocation);
                store.commit('setUseTowVehicleTrueLocation', data?.value?.useTowVehicleTrueLocation);
                // await store.dispatch("updateDetailData", data.value);
                store.commit('setTowVehicle', data?.value?.towVehicleDetails?.vehicle);
                store.commit('setImages', []);
                if (data.value?.towVehicleDetails?.media &&
                    data.value?.towVehicleDetails?.media.length) {
                    store.commit('setImages', data.value?.towVehicleDetails.media);
                }
                // store.commit("setIsDestinationReached", true);
            }
            catch (err) {
                console.error('API request failed:', err);
                error.value = 'Failed to load data';
            }
            finally {
                loading.value = false;
            }
        });
        const buttonDisable = computed(() => {
            if (finalClick.value === true) {
                return true;
            }
            if (towVehicleStatus.value === TowVehicleServiceBookingStatus.STARTED &&
                endTaskClicked.value &&
                signature.value === '') {
                return true;
            }
            if (towVehicleStatus.value === TowVehicleServiceBookingStatus.STARTED &&
                isDestinationReached.value &&
                signature.value !== '') {
                return false;
            }
            return false;
        });
        const buttonLabel = computed(() => {
            const imagesForStatus = images.value.filter((e) => towVehicleStatus.value === TowVehicleServiceBookingStatus.PICKUP
                ? e.type === TowVehicleMediaType.COMPLETED
                : towVehicleStatus.value === TowVehicleServiceBookingStatus.STARTED
                    ? e.type === TowVehicleMediaType.ARRIVED
                    : e.type === towVehicleStatus.value);
            if ((towVehicleStatus.value === TowVehicleServiceBookingStatus.STARTED &&
                isDestinationReached.value &&
                imagesForStatus.length === 0) ||
                (towVehicleStatus.value === TowVehicleServiceBookingStatus.PICKUP &&
                    isDestinationReached.value &&
                    imagesForStatus.length === 0)) {
                return 'Upload Photo & Continue';
            }
            if (towVehicleStatus.value === TowVehicleServiceBookingStatus.STARTED &&
                endTaskClicked.value) {
                return 'Submit';
            }
            if ((towVehicleStatus.value === TowVehicleServiceBookingStatus.STARTED &&
                isDestinationReached.value &&
                !endTaskClicked.value) ||
                (towVehicleStatus.value === TowVehicleServiceBookingStatus.PICKUP &&
                    isDestinationReached.value)) {
                return 'End Task';
            }
            if (towVehicleStatus.value === TowVehicleServiceBookingStatus.ARRIVED) {
                return 'Tow to service center';
            }
            return 'Start Now';
        });
        // const buttonLabelArrived = computed(() => {
        //   if (towVehicleStatus.value === TowVehicleServiceBookingStatus.ARRIVED) {
        //     return "End Task";
        //   }
        //   if (
        //     towVehicleStatus.value === TowVehicleServiceBookingStatus.PICKUP &&
        //     isDestinationReached.value
        //   ) {
        //     return "End Task";
        //   }
        //   return "Tow To Garage";
        // });
        const popupLabel = computed(() => {
            if ((towVehicleStatus.value === TowVehicleServiceBookingStatus.STARTED &&
                isDestinationReached.value) ||
                (towVehicleStatus.value === TowVehicleServiceBookingStatus.PICKUP &&
                    isDestinationReached.value)) {
                return 'Are you sure you want to end the session?';
            }
            else {
                return 'Are you sure you want to start the session?';
            }
        });
        const endTaskButtonHandler = (eventData) => {
            console.log('Selected Reasons: ', eventData.reasons);
            reasons.value = eventData.reasons;
            console.log('Comment: ', eventData.comment);
            comment.value = eventData.comment;
            endTaskClicked.value = true;
            toggle();
        };
        const towToGarageButtonHandler = () => {
            towToGarageClicked.value = true;
            toggle();
        };
        const submitHandler = () => {
            if (towVehicleStatus.value === TowVehicleServiceBookingStatus.STARTED &&
                isDestinationReached.value &&
                signature.value === '') {
                return;
            }
            if (towVehicleStatus.value === TowVehicleServiceBookingStatus.STARTED &&
                isDestinationReached.value) {
                console.log('onStartCompleted');
                onStartCompleted();
            }
            else if (towVehicleStatus.value === TowVehicleServiceBookingStatus.PICKUP &&
                isDestinationReached.value) {
                console.log('onDropComplete');
                finalClick.value = true;
                onDropComplete();
            }
            else {
                console.log('onStart');
                onStart();
            }
        };
        const buttonHandler = () => {
            if (towVehicleStatus.value === TowVehicleServiceBookingStatus.STARTED &&
                isDestinationReached.value) {
                onStartCompleted();
            }
            else if (towVehicleStatus.value === TowVehicleServiceBookingStatus.PICKUP &&
                isDestinationReached.value) {
                onDropComplete();
            }
            else {
                onStart();
            }
        };
        const arriveButtonHandler = () => {
            if (towVehicleStatus.value === TowVehicleServiceBookingStatus.PICKUP &&
                isDestinationReached.value) {
                onDropComplete();
            }
            else {
                onPickUp();
            }
        };
        const onStart = async () => {
            try {
                const param = route.params.id || route.fullPath.split('/').pop();
                if (!param) {
                    throw new Error('Parameter is missing');
                }
                const baseUrl = getApiBaseUrl() || process.env.VUE_APP_BASE_URL;
                const payload = {
                    location: {
                        address: data.value?.customerLocation?.address ||
                            data.value?.customerLocation?.line1,
                        latitude: data.value?.customerLocation?.location.latitude,
                        longitude: data.value?.customerLocation?.location.longitude,
                        type: TowVehicleLocationType.STARTED,
                    },
                };
                const response = await axios.post(`${baseUrl}/tow-vehicle/road-assistance-started/${param}`, payload);
                // console.log("response", response);
                data.value = response.data.data;
                // Update tow vehicle status in Vuex store
                await store.dispatch('updateTowVehicleStatus', data.value?.towVehicleDetails?.status || '');
                // store.commit("setDetail", data.value);
                store.commit('setUseTowVehicleTrueLocation', data?.value?.useTowVehicleTrueLocation);
                // await store.dispatch("updateDetailData", data.value);
                toggle();
                await store.dispatch('fetchGpsProviderToken');
                const deviceId = data.value?.towVehicleDetails?.vehicle?.deviceId;
                if (!deviceId) {
                    throw new Error('Device ID is missing');
                }
                if (response.data?.data?.callLocationApiFromFrontend &&
                    project === 'ultimate') {
                    // const vehicleDetails = await store.dispatch(
                    await store.dispatch('fetchVehicleDetails', deviceId);
                    // console.log(vehicleDetails);
                }
                else {
                    // gps
                    // const vehicleDetails = await store.dispatch(
                    await store.dispatch('fetchLiveLocation', deviceId);
                    // console.log(vehicleDetails);
                }
            }
            catch (err) {
                console.error('API request failed:', err);
                error.value = 'Failed to load data';
            }
            finally {
                loading.value = false;
            }
        };
        const onStartCompleted = async () => {
            try {
                const param = route.params.id || route.fullPath.split('/').pop();
                if (!param) {
                    throw new Error('Parameter is missing');
                }
                const baseUrl = getApiBaseUrl() || process.env.VUE_APP_BASE_URL;
                // Extract images value
                const imagesValue = images.value;
                // Prepare the payload with images
                const payload = {
                    media: imagesValue.filter((e) => e.type === TowVehicleMediaType.ARRIVED),
                    reasons: reasons.value,
                    signature: signature.value,
                    comment: comment.value,
                    rating: currentRating.value,
                    location: {
                        address: data.value?.customerLocation?.address ||
                            data.value?.customerLocation?.line1,
                        latitude: data.value?.customerLocation?.location.latitude,
                        longitude: data.value?.customerLocation?.location.longitude,
                        type: TowVehicleLocationType.ARRIVED,
                    },
                };
                // console.log("payload", payload);
                // Send the request with the payload
                const response = await axios.post(`${baseUrl}/tow-vehicle/road-assistance-arrived/${param}`, payload);
                data.value = response.data.data;
                store.commit('setImages', []);
                store.dispatch('updateTowVehicleStatus', data.value?.towVehicleDetails?.status || '');
                // store.commit("setDetail", data.value);
                store.commit('setUseTowVehicleTrueLocation', data?.value?.useTowVehicleTrueLocation);
                // await store.dispatch("updateDetailData", data.value);
                store.commit('setImages', data.value?.towVehicleDetails.media);
                store.commit('setIsDestinationReached', false);
                toggle();
                // toggle();
            }
            catch (err) {
                console.error('API request failed:', err);
                error.value = 'Failed to load data';
            }
            finally {
                loading.value = false;
            }
        };
        console.log('dadf', selectedServiceCenter.value?.serviceCenter?.title, selectedServiceCenter.value?.note);
        watch(selectedServiceCenter, (newValue) => {
            if (newValue) {
                console.log('sdfasdfsfsdf', newValue);
                selectedServiceCenter.value = newValue;
                // emit("update:value", { serviceCenter: newValue, note: noteRef.value });
            }
        });
        const onPickUp = async () => {
            try {
                await nextTick();
                console.log('newdata service cnete', selectedServiceCenter.value.serviceCenter, selectedServiceCenter.value?.note);
                // return;
                const param = route.params.id || route.fullPath.split('/').pop();
                if (!param) {
                    throw new Error('Parameter is missing');
                }
                // store.commit("setRoadAssistanceId", param);
                const baseUrl = getApiBaseUrl() || process.env.VUE_APP_BASE_URL;
                const payload = {
                    status: TowVehicleServiceBookingStatus.PICKUP,
                    location: {
                        address: data.value?.customerLocation?.address ||
                            data.value?.customerLocation?.line1,
                        latitude: data.value?.customerLocation?.location.latitude,
                        longitude: data.value?.customerLocation?.location.longitude,
                        type: TowVehicleLocationType.PICKUP,
                    },
                    serviceCenterId: selectedServiceCenter.value.serviceCenter,
                    notes: selectedServiceCenter.value?.note,
                };
                const response = await axios.post(`${baseUrl}/tow-vehicle/road-assistance-status/${param}`, payload);
                data.value = response.data.data;
                await store.dispatch('updateTowVehicleStatus', data.value?.towVehicleDetails?.status || '');
                // store.commit("setDetail", data.value);
                store.commit('setUseTowVehicleTrueLocation', data?.value?.useTowVehicleTrueLocation);
                // await store.dispatch("updateDetailData", data.value);
                store.commit('setTowVehicle', data?.value?.towVehicleDetails?.vehicle);
                store.commit('setImages', []);
                if (data.value?.towVehicleDetails?.media &&
                    data.value?.towVehicleDetails?.media.length) {
                    store.commit('setImages', data.value?.towVehicleDetails.media);
                }
                // Update tow vehicle status in Vuex store
                // store.commit("setImages", []);
                // await store.dispatch(
                //   "updateTowVehicleStatus",
                //   response?.data?.data?.towVehicleDetails?.status || ""
                // );
                // store.commit("setImages", response?.data?.data?.towVehicleDetails.media);
                store.commit('setIsDestinationReached', false);
                // toggle();
                await store.dispatch('fetchGpsProviderToken');
                const deviceId = data.value?.towVehicleDetails?.vehicle?.deviceId;
                if (!deviceId) {
                    throw new Error('Device ID is missing');
                }
                if (response.data?.data?.callLocationApiFromFrontend &&
                    project === 'ultimate') {
                    // const vehicleDetails = await store.dispatch(
                    await store.dispatch('fetchVehicleDetails', deviceId);
                    // console.log(vehicleDetails);
                }
                else {
                    //gpsconst
                    // const vehicleDetails = await store.dispatch(
                    await store.dispatch('fetchLiveLocation', deviceId);
                    // console.log(vehicleDetails);
                }
            }
            catch (err) {
                console.error('API request failed:', err);
                error.value = 'Failed to load data';
            }
            finally {
                loading.value = false;
                reasons.value = [];
                store.commit('setIsDestinationReached', true);
                // await store.commit("setIsDestinationReached", true);
                // componentKey.value++;
            }
        };
        const onDropComplete = async () => {
            try {
                const param = route.params.id || route.fullPath.split('/').pop();
                if (!param) {
                    throw new Error('Parameter is missing');
                }
                const baseUrl = getApiBaseUrl() || process.env.VUE_APP_BASE_URL;
                // Extract images value
                const imagesForStatus = images.value.filter((e) => e.type === TowVehicleMediaType.COMPLETED);
                // Prepare the payload with images
                // const payload = {
                //   media: imagesForStatus,
                //   location: {
                //     address: data.value?.serviceCenter?.address?.address,
                //     latitude: data.value?.serviceCenter?.location.latitude,
                //     longitude: data.value?.serviceCenter?.location.longitude,
                //     type: TowVehicleLocationType.COMPLETED,
                //   },
                //   serviceCenterId: selectedServiceCenter.value.serviceCenter,
                //   notes: selectedServiceCenter.value?.note,
                // };
                const serviceAddress = data.value?.towVehicleDetails?.vehicle?.serviceCenters?.find((e) => e._id === selectedServiceCenter.value.serviceCenter)?.location;
                const payload = {
                    media: imagesForStatus,
                    location: {
                        address: serviceAddress?.address,
                        latitude: serviceAddress?.latitude,
                        longitude: serviceAddress?.longitude,
                        type: TowVehicleLocationType.COMPLETED,
                    },
                    serviceCenterId: selectedServiceCenter.value.serviceCenter,
                    notes: selectedServiceCenter.value?.note,
                };
                const response = await axios.post(`${baseUrl}/tow-vehicle/road-assistance-completed/${param}`, payload);
                data.value = response.data.data;
                // Update tow vehicle status in Vuex store
                store.dispatch('updateTowVehicleStatus', data.value?.towVehicleDetails?.status || '');
                store.commit('setUseTowVehicleTrueLocation', data?.value?.useTowVehicleTrueLocation);
                // await store.dispatch("updateDetailData", data.value);
                toggle();
            }
            catch (err) {
                console.error('API request failed:', err);
                error.value = 'Failed to load data';
            }
            finally {
                loading.value = false;
            }
        };
        function toggle() {
            spanVisible.value = !spanVisible.value;
        }
        function closeBottomSheet() {
            spanVisible.value = !spanVisible.value;
            towToGarageClicked.value = false;
        }
        const triggerFileUpload = () => {
            fileInput.value?.click();
        };
        const handleFileUpload = async (event) => {
            const target = event.target;
            if (target.files && target.files[0]) {
                const file = target.files[0];
                await store.dispatch('uploadImage', file);
                // onStartCompleted();
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", null, [
                    (loading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                            _createElementVNode("img", {
                                src: require(`../assets/${loader.value[_unref(project)]}`),
                                alt: "loading..."
                            }, null, 8, _hoisted_2)
                        ]))
                        : (error.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(error.value), 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                (data.value &&
                                    (towVehicleStatus.value === _unref(TowVehicleServiceBookingStatus).PENDING ||
                                        towVehicleStatus.value === _unref(TowVehicleServiceBookingStatus).STARTED ||
                                        towVehicleStatus.value === _unref(TowVehicleServiceBookingStatus).PICKUP))
                                    ? (_openBlock(), _createBlock(MainLayout, {
                                        key: 0,
                                        data: data.value
                                    }, {
                                        default: _withCtx(() => [
                                            (reasons.value.length > 0)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
                                                : _createCommentVNode("", true),
                                            (towVehicleStatus.value !== _unref(TowVehicleServiceBookingStatus).COMPLETED &&
                                                towVehicleStatus.value !== _unref(TowVehicleServiceBookingStatus).CANCELLED)
                                                ? (_openBlock(), _createBlock(InfoBlock, {
                                                    key: 1,
                                                    data: data.value
                                                }, null, 8, ["data"]))
                                                : _createCommentVNode("", true),
                                            (towVehicleStatus.value === _unref(TowVehicleServiceBookingStatus).PENDING ||
                                                towVehicleStatus.value === _unref(TowVehicleServiceBookingStatus).STARTED ||
                                                towVehicleStatus.value === _unref(TowVehicleServiceBookingStatus).ARRIVED)
                                                ? (_openBlock(), _createBlock(LocationBLock, {
                                                    key: 2,
                                                    data: data.value
                                                }, null, 8, ["data"]))
                                                : _createCommentVNode("", true),
                                            (towVehicleStatus.value === _unref(TowVehicleServiceBookingStatus).PICKUP)
                                                ? (_openBlock(), _createBlock(LocationBlockToGarage, {
                                                    key: 3,
                                                    data: data.value
                                                }, null, 8, ["data"]))
                                                : _createCommentVNode("", true),
                                            (reasons.value.length > 0)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                                    (reasons.value.length > 0)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Selected Reason "))
                                                        : _createCommentVNode("", true),
                                                    _createElementVNode("ul", null, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reasons.value, (reason, index) => {
                                                            return (_openBlock(), _createElementBlock("li", { key: reason }, _toDisplayString(index + 1) + ". " + _toDisplayString(reason), 1));
                                                        }), 128))
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true),
                                            ((towVehicleStatus.value === _unref(TowVehicleServiceBookingStatus).ARRIVED ||
                                                towVehicleStatus.value === _unref(TowVehicleServiceBookingStatus).PICKUP ||
                                                images.value.length > 0) &&
                                                towVehicleStatus.value !== _unref(TowVehicleServiceBookingStatus).COMPLETED)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                                    (images.value.length > 0)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, "Task Photos"))
                                                        : _createCommentVNode("", true),
                                                    (towVehicleStatus.value === _unref(TowVehicleServiceBookingStatus).PENDING ||
                                                        towVehicleStatus.value === _unref(TowVehicleServiceBookingStatus).STARTED ||
                                                        towVehicleStatus.value === _unref(TowVehicleServiceBookingStatus).PICKUP)
                                                        ? (_openBlock(), _createBlock(ImgGallery, {
                                                            key: 1,
                                                            data: data.value,
                                                            title: "Arrival photos",
                                                            status: _unref(TowVehicleServiceBookingStatus).ARRIVED
                                                        }, null, 8, ["data", "status"]))
                                                        : _createCommentVNode("", true),
                                                    (data.value.towVehicleDetails.media && data.value.towVehicleDetails.media.filter((e) => e.type === _unref(TowVehicleMediaType).COMPLETED).length > 0 && isDestinationReached.value && towVehicleStatus.value === _unref(TowVehicleServiceBookingStatus).PICKUP)
                                                        ? (_openBlock(), _createBlock(ImgGallery, {
                                                            key: 2,
                                                            data: data.value,
                                                            title: "Drop Off photos",
                                                            status: _unref(TowVehicleServiceBookingStatus).COMPLETED
                                                        }, null, 8, ["data", "status"]))
                                                        : _createCommentVNode("", true)
                                                ]))
                                                : _createCommentVNode("", true),
                                            (reasons.value.length > 0)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                                    _hoisted_14,
                                                    _createVNode(RatingStar, {
                                                        rating: currentRating.value,
                                                        "onUpdate:rating": updateRating
                                                    }, null, 8, ["rating"])
                                                ]))
                                                : _createCommentVNode("", true),
                                            (reasons.value.length > 0)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                                    (reasons.value.length > 0)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, " Customer Signature "))
                                                        : _createCommentVNode("", true),
                                                    _createVNode(SignaturePad, { onSignatureSaved: handleSignatureSave })
                                                ]))
                                                : _createCommentVNode("", true),
                                            (towVehicleStatus.value === _unref(TowVehicleServiceBookingStatus).PENDING ||
                                                towVehicleStatus.value === _unref(TowVehicleServiceBookingStatus).STARTED ||
                                                towVehicleStatus.value === _unref(TowVehicleServiceBookingStatus).PICKUP)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                                    (towVehicleStatus.value === _unref(TowVehicleServiceBookingStatus).PENDING &&
                                                        !endTaskClicked.value.value)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                                            _createVNode(DButton, {
                                                                primary: "",
                                                                value: buttonLabel.value,
                                                                onClick: toggle
                                                            }, null, 8, ["value"])
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    ((towVehicleStatus.value === _unref(TowVehicleServiceBookingStatus).STARTED ||
                                                        towVehicleStatus.value === _unref(TowVehicleServiceBookingStatus).PICKUP) &&
                                                        isDestinationReached.value)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                                            (images.value.length === 0)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                                                    _createTextVNode(" To finalize the task, take a photo to confirm"),
                                                                    _hoisted_21,
                                                                    _createTextVNode(" the job is complete. ")
                                                                ]))
                                                                : _createCommentVNode("", true),
                                                            _createVNode(DButton, {
                                                                primary: "",
                                                                value: buttonLabel.value,
                                                                disable: buttonDisable.value,
                                                                onClick: handleButtonClick
                                                            }, null, 8, ["value", "disable"]),
                                                            _createElementVNode("input", {
                                                                type: "file",
                                                                ref_key: "fileInput",
                                                                ref: fileInput,
                                                                onChange: handleFileUpload,
                                                                accept: "image/*",
                                                                style: { "display": "none" }
                                                            }, null, 544)
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    (spanVisible.value &&
                                                        (towVehicleStatus.value === _unref(TowVehicleServiceBookingStatus).PENDING ||
                                                            towVehicleStatus.value === _unref(TowVehicleServiceBookingStatus).ARRIVED ||
                                                            towToGarageClicked.value))
                                                        ? (_openBlock(), _createBlock(BottomSheet, {
                                                            key: 2,
                                                            value: popupLabel.value,
                                                            onClose: closeBottomSheet,
                                                            onStart: buttonHandler
                                                        }, null, 8, ["value"]))
                                                        : _createCommentVNode("", true),
                                                    (spanVisible.value &&
                                                        !towToGarageClicked.value &&
                                                        towVehicleStatus.value === _unref(TowVehicleServiceBookingStatus).STARTED)
                                                        ? (_openBlock(), _createBlock(EndTaskSheet, {
                                                            key: 3,
                                                            value: popupLabel.value,
                                                            onClose: toggle,
                                                            onStart: endTaskButtonHandler
                                                        }, null, 8, ["value"]))
                                                        : _createCommentVNode("", true)
                                                ]))
                                                : _createCommentVNode("", true),
                                            (towVehicleStatus.value === _unref(TowVehicleServiceBookingStatus).ARRIVED ||
                                                (towVehicleStatus.value === _unref(TowVehicleServiceBookingStatus).STARTED &&
                                                    imagesForStatus.value.length > 0) ||
                                                (towVehicleStatus.value === _unref(TowVehicleServiceBookingStatus).PICKUP &&
                                                    !isDestinationReached.value &&
                                                    imagesForStatus.value.length > 0))
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                                    (towVehicleStatus.value === _unref(TowVehicleServiceBookingStatus).ARRIVED)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                                            _createElementVNode("div", _hoisted_24, [
                                                                _hoisted_25,
                                                                _createVNode(DButton, {
                                                                    link: "",
                                                                    value: "Tow to service center",
                                                                    onClick: towToGarageButtonHandler
                                                                })
                                                            ])
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    (spanVisible.value &&
                                                        towVehicleStatus.value === _unref(TowVehicleServiceBookingStatus).ARRIVED)
                                                        ? (_openBlock(), _createBlock(BottomSheet, {
                                                            key: 1,
                                                            onClose: toggle,
                                                            onStart: arriveButtonHandler
                                                        }))
                                                        : _createCommentVNode("", true)
                                                ]))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                    }, 8, ["data"]))
                                    : _createCommentVNode("", true)
                            ]))
                ]),
                (towVehicleStatus.value === _unref(TowVehicleServiceBookingStatus).ARRIVED ||
                    towVehicleStatus.value === _unref(TowVehicleServiceBookingStatus).COMPLETED)
                    ? (_openBlock(), _createBlock(ThankYou, {
                        key: 0,
                        onOnPickUpStart: onPickUp,
                        value: selectedServiceCenter.value,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event) => ((selectedServiceCenter).value = $event))
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(" > ")
                        ]),
                        _: 1
                    }, 8, ["value"]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
